import React from 'react';
import JepsplSection from '../../../../course/churchschool/JepsplSection';
import WarningSection from '../../../../course/churchschool/WarningSection';
import HFHJSection8b from '../../../../course/churchschool/hfhj/HFHJSection8b';
import HFHJSection14 from '../../../../course/churchschool/hfhj/HFHJSection14';
import GodDealWeekSectionOct, {
  IS_DISPLAY_GODDEAL_SECTION,
} from '../../../../course/churchschool/event/GodDealWeekSectionOct';

const BoostupHJBookMain = () => {
  return (
    <>
      {IS_DISPLAY_GODDEAL_SECTION && <GodDealWeekSectionOct />}
      <HFHJSection8b />
      <WarningSection />
      <JepsplSection />
      <HFHJSection14 />
    </>
  );
};

export default BoostupHJBookMain;
